import React, { useRef } from "react";
import Footer from "../components/Footer";

export default function PaymentRefundTerms() {
    const footerRef = useRef(null);

    const paymentRefundTerms = `Условия оплаты и возврата
Условия оплаты и возврата для пользователей приложения «Аквамаркет Тибетская» применяются совместно с публичной офертой ТОО «Verto Business (Верто Бизнес)» — Оператора сервиса.

1. Способы оплаты
Оплата заказа производится путём списания средств с внутреннего баланса пользователя либо иными способами, доступными в приложении при оформлении заказа.
Пополнение внутреннего баланса обрабатывается платёжным оператором. В банковской выписке получателем средств указывается ТОО «Verto Business».

2. Стоимость заказа
Стоимость заказа или сервисного пакета указывается в приложении. Изменение цен не распространяется на уже оформленные и подтверждённые Оператором заказы, а также на оплаченные сервисные пакеты, находящиеся на балансе пользователя на момент изменения цен.

3. Внутренний баланс
Средства на внутреннем балансе используются только для оплаты заказов в приложении. Внутренний баланс не является депозитом, вкладом, банковским счётом или электронными деньгами.

4. Возврат товара
При получении заказа пользователь проверяет целостность заводской упаковки и тары, а также количество бутылей. При явных повреждениях или несоответствии количества пользователь вправе отказаться от приёмки такого товара, составив акт совместно с представителем службы доставки.
Если после приёмки обнаружены скрытые недостатки товара, пользователь вправе предъявить претензию в порядке и сроки, установленные Законом Республики Казахстан «О защите прав потребителей».

5. Возврат денежных средств
Возврат ошибочного пополнения баланса осуществляет платёжный оператор в соответствии с законодательством Республики Казахстан.
Пользователь вправе запросить возврат неиспользованного остатка внутреннего баланса, в том числе при удалении профиля. Оператор осуществляет возврат в течение 10 рабочих дней с момента получения запроса.
Средства возвращаются тем же способом, которым производилось пополнение, если иной способ не согласован сторонами и не противоречит законодательству Республики Казахстан. Удаление профиля не освобождает пользователя от оплаты уже подтверждённых и неоплаченных заказов.

6. Обращения и реквизиты
Запрос о возврате направляется на info@tibetskaya.kz либо в письменном виде на адрес Оператора. Порядок удаления профиля и расторжения соглашения приведён в публичной оферте. Срок рассмотрения письменной претензии — 10 календарных дней.
ТОО «Verto Business (Верто Бизнес)», БИН 220340005670. Адрес: Республика Казахстан, 050045, г. Алматы, мкр. Нурлытау, ул. Г. Баязитовой, д. 12. Телефон: +7 (701) 531-55-58.
Полная публичная оферта: www.tibetskaya.kz/PublicOffer.
`

    const formattedTerms = paymentRefundTerms.split('\n').map((paragraph, index) => {
        if (paragraph.trim() === "") return null; // Пропускаем пустые строки
        return paragraph.startsWith(' ') ? <p key={index}>{paragraph.trim()}</p> : <h3 key={index}>{paragraph.trim()}</h3>;
    });

    return (
        <div className="flex flex-col min-h-screen justify-between">
            <div className="pt-5 px-5 space-y-3">
                <h2 className="text-lg font-bold">УСЛОВИЯ ОПЛАТЫ И ВОЗВРАТА</h2>
                {formattedTerms}
            </div>

            <div className="">
                <Footer ref={footerRef} phone="+7 701 531 55 58" mail="info@tibetskaya.kz" />
            </div>
        </div>
    );
}
